import React from "react";
import ReactScroll from "react-scroll";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/es/integration/react";
import { createBrowserHistory } from "history";
import { ThemeProvider } from "@mui/material/styles";
import Routes from "./routes/index.jsx";
import ErrorBoundary from "./error-boundary.jsx";
import Loader from "./loader.jsx";
import Snackbar from "./components/snackbar.jsx";
import configureStore from "./config/configure-store";
import theme from "./config/configure-theme";
import "./utility/prototype-methods";
import "./firebase/index";

export const history = createBrowserHistory();

const {
  persistor, store,
} = configureStore(history);

let prevLocation = {};

history.listen((location) => {
  const pathChanged = prevLocation?.pathname !== location.pathname;
  const hashChanged = prevLocation?.hash !== location.hash;

  if (pathChanged || hashChanged) {
    ReactScroll.animateScroll.scrollToTop();
  }

  prevLocation = location;
});

const BemovedApplication = () => (
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<Loader visible />}>
        <>
          <ConnectedRouter history={history}>
            <ErrorBoundary>
              <React.Suspense fallback={<Loader visible />}>
                <Routes />
              </React.Suspense>
            </ErrorBoundary>
          </ConnectedRouter>
          <Loader />
          <Snackbar />
        </>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

export default BemovedApplication;
